var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20409 -1865)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20409 1865)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20403.678 1872.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4819.818,4710.531a.92.92,0,0,1-.22.159c-.53.186-.635.555-.628,1.09a.827.827,0,0,0,.564.911c.295.108.376.3.216.576-.251.435-.5.869-.768,1.3a.306.306,0,0,1-.5.093c-.083-.064-.19-.1-.274-.158a.441.441,0,0,0-.656.044.218.218,0,0,1-.088.058.946.946,0,0,0-.744,1.182c.014.07-.137.244-.215.247-.582.022-1.166.019-1.749.012-.217,0-.281-.167-.249-.347.1-.534-.153-.789-.609-1.054a.859.859,0,0,0-1.125.006.315.315,0,0,1-.528-.1c-.275-.461-.538-.93-.8-1.4a.266.266,0,0,1,.168-.42c.561-.178.657-.563.649-1.108-.006-.443-.123-.713-.528-.86-.341-.123-.423-.335-.229-.65.256-.42.5-.848.763-1.264a.283.283,0,0,1,.471-.083.937.937,0,0,0,1.224,0,.862.862,0,0,0,.54-.96c-.037-.264.063-.442.359-.439.536,0,1.073,0,1.606.036.084.006.233.224.217.322-.1.593.184.873.681,1.16a.784.784,0,0,0,.991-.026c.27-.195.492-.177.666.135.227.409.468.811.7,1.22A1.833,1.833,0,0,1-4819.818,4710.531Zm-4.212-.059a1.212,1.212,0,0,0-1.277,1.277,1.228,1.228,0,0,0,1.3,1.3,1.215,1.215,0,0,0,1.271-1.289A1.2,1.2,0,0,0-4824.03,4710.472Z",
    transform: "translate(4844.332 -4695.892)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4981.845,4747.716h.5c2.425,0,4.851,0,7.277-.006a.549.549,0,0,1,.531.293c.355.535.768,1.032,1.159,1.547a.177.177,0,0,1-.092.029q-5.068,0-10.138-.014c-.882,0-1.245-.425-1.194-1.3a5.364,5.364,0,0,1,4.339-4.835,6.408,6.408,0,0,1,1.048-.107c1.354-.012,2.708,0,4.063,0h.284c-.093.55-.192,1.076-.269,1.606-.037.251-.209.212-.369.212-1.118,0-2.237.006-3.355,0a4.286,4.286,0,0,0-2.2.531,3.525,3.525,0,0,0-1.537,1.784A1.72,1.72,0,0,0-4981.845,4747.716Z",
    transform: "translate(4988.903 -4729.299)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4929.827,4608.216a3.986,3.986,0,0,1,4.054,4.076,3.987,3.987,0,0,1-4.075,4.1,3.956,3.956,0,0,1-4.039-3.937A4.024,4.024,0,0,1-4929.827,4608.216Zm-.013,6.312a2.22,2.22,0,0,0,2.258-2.225,2.228,2.228,0,0,0-2.239-2.242,2.185,2.185,0,0,0-2.263,2.242A2.183,2.183,0,0,0-4929.839,4614.528Z",
    transform: "translate(4942.514 -4603.745)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4812.759,4548.134a3.024,3.024,0,0,1,3.14-3.151,3.029,3.029,0,0,1,3.123,3.17,3.067,3.067,0,0,1-3.142,3.113A3.059,3.059,0,0,1-4812.759,4548.134Z",
    transform: "translate(4829.942 -4544.983)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5025.756,4551.318a3.08,3.08,0,0,1-3.148-3.11,3.009,3.009,0,0,1,3.152-3.169,3.009,3.009,0,0,1,3.131,3.155A3.078,3.078,0,0,1-5025.756,4551.318Z",
    transform: "translate(5030.817 -4545.034)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5047.482,4657.1c-.189.021-.324.048-.459.048q-3.459.005-6.918,0a2.843,2.843,0,0,1-.421-.037.692.692,0,0,1-.682-.783,3.562,3.562,0,0,1,3.506-3.6c.951-.017,1.9.021,2.855.036a.891.891,0,0,1,.173.028c.7.159.683.159.7.87a5.413,5.413,0,0,0,.967,3.046Z",
    transform: "translate(5055.963 -4645.11)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4806.84,4655.912a5.419,5.419,0,0,0,.484-2.689.287.287,0,0,1,.161-.22,3.23,3.23,0,0,1,.885-.217,31.687,31.687,0,0,1,3.173.03,3.5,3.5,0,0,1,3.049,3.539,1.1,1.1,0,0,1-.051.347.579.579,0,0,1-.979.234,5.219,5.219,0,0,0-2.526-1.469,5.581,5.581,0,0,0-3.789.283C-4806.534,4655.794-4806.639,4655.833-4806.84,4655.912Z",
    transform: "translate(4824.442 -4645.146)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.08628a44.svg";
export { ForwardRef as ReactComponent };